var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vs-table',{ref:"table",attrs:{"params":_vm.params,"options":_vm.options},on:{"onCreateHeaderActionClicked":_vm.createBankAccount}}),_c('div',{ref:"container"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }